<template>
  <div class>
    <div class="about-container">
      <div class="container about-box">
        <hometitle class="fzlc-title" :title="aboutTitle" :subtitle="aboutSubTitle"></hometitle>
        <swiper class="row fzlc-swiper" :options="fzlcSwiper">
          <swiper-slide class="fzlc-items" v-for="(item, index) in fzlcData" :key="index">
            <p class="fzlc-time">{{item.date}}</p>
            <div class="fzlc-hengxian"></div>
            <div class="fzlc-zhanwei"></div>
            <ul class="fzlc-body-box">
              <li class="fzlc-body-item">{{item.body}}</li>
            </ul>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>
<script>
import HoemTitle from '../components/HomeTitle'
import deveDataCN from '../data/CN/deveData_CN.json'
import deveDataEN from '../data/EN/deveData_EN.json'
import deveDataJP from '../data/JP/deveData_JP.json'
export default {
  props: {
    isAbout: { type: Boolean }
  },
  data() {
    return {
      aboutTitle: '发展历程',
      aboutSubTitle: 'Development',
      fzlcSwiper: {
        slidesPerView: 4,
        spaceBetween: 0,
        direction: 'horizontal'
      },
      fzlcData: []
    }
  },
  mounted() {
      const _this = this
      window.addEventListener('setItemEvent', function(e) {
          // e.key : 是值发生变化的key
          // 例如 e.key==="token";
          // e.newValue : 是可以对应的新值
          if (e.key === 'language') {
              var d = e.newValue
            _this.currentLanguage = e.newValue
              if (d === 'CN') {
                  _this.fzlcData = deveDataCN
              } else if (d === 'EN') {
                  _this.fzlcData = deveDataEN
              } else if (d === 'JP') {
                  _this.fzlcData = deveDataJP
              }
          }
      })
  },
  methods: {
    // 查询所有的发展历程
    findBasicinfo: async function() {
      var lg = localStorage.getItem('language')
      this.currentLanguage = lg
      if (lg === 'CN') {
          this.fzlcData = deveDataCN
      } else if (lg === 'EN') {
          this.fzlcData = deveDataEN
      } else if (lg === 'JP') {
          this.fzlcData = deveDataJP
      }
      
    }
  },
  created() {
    this.findBasicinfo()
  },
  components: {
    hometitle: HoemTitle
  }
}
</script>

<style scoped>
.about-container {
  padding-top: 40px;
  width: 100%;
}
.about-box {
  height: 100%;
}
.fzlc-swiper {
  position: relative;
  margin-bottom: 40px;
}
.fzlc-title {
  margin-bottom: 10px !important;
}
.fzlc-items {
  padding: 20px;
  text-align: center;
  color: #666;
  height: 100%;
}
.fzlc-time {
  height: 80px;
  line-height: 80px;
}
.fzlc-body-box {
  height: 120px;
  line-height: 30px;
  padding-top: 20px;
}
.fzlc-body-item {
  vertical-align: middle;
}
.fzlc-body-item::before {
  content: '';
  margin-bottom: 3px;
  margin-right: 10px;
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #666;
}
.fzlc-hengxian {
  position: absolute;
  width: 100%;
  height: 2px;
  left: 0;
  top: 40%;
  transform: translateY(-50%);
  background: #ccc;
}
.fzlc-hengxian::before {
  content: '';
  display: inline-block;
  position: absolute;
  width: 14px;
  height: 14px;
  background: #666;
  transform: translateY(-50%);
  border-radius: 50%;
  z-index: 1;
}
</style>